/* eslint-env es6 */
let macOS = navigator.userAgent.indexOf('Mac OS X') != -1;
let keys = {
    K:     75,
    R:     82,
    ENTER: 13,
    BACKSPACE: 8,
    TAB:    9,
    SHIFT:  16,
    ALT:   18,
    CMD: 91,
    CTRL: 17,
    ESC:   27,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT:  37,
    UP:    38,
    RIGHT: 39,
    DOWN:  40,
    COMMA: 188,
    '/':   191
};

export default {
    isClickEnter (e) {
        // Mouse clicks have a positive detail count to signify how many clicks
        return e.originalEvent.detail === 0;
    },
    modifierName() {
        if (macOS) {
            return 'Cmd';
        } else {
            return 'Ctrl';
        }
    },
    modifierLabel() {
        if (macOS) {
            return 'command';
        } else {
            return 'control';
        }
    },
    isModifier(e, allowAltShift) {
        if (!allowAltShift && (e.altKey || e.shiftKey)) {
            return false;
        }
        if (macOS) {
            return e.metaKey && !e.ctrlKey;
        } else {
            return e.ctrlKey;
        }
    },
    isModifierWhich(e) {
        if (macOS) {
            return e.which == keys.CMD;
        } else {
            return e.which == keys.CTRL;
        }
    },
    KEYS: keys
};



// WEBPACK FOOTER //
// ./app/src/lib/keyboard.es6